import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../api';
import './OfferList.css';

function OfferList() {
  const navigate = useNavigate();
  const [offers, setOffers] = useState([]);
  const [filteredOffers, setFilteredOffers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [statusFilter, setStatusFilter] = useState('all');

  useEffect(() => {
    fetchOffers();
  }, []);

  useEffect(() => {
    filterOffers();
  }, [statusFilter, offers]);

  const fetchOffers = async () => {
    try {
      setLoading(true);
      const response = await api.get('/offers');
      setOffers(response.data.data);
      setFilteredOffers(response.data.data);
    } catch (error) {
      console.error('Teklifler yüklenemedi:', error);
    } finally {
      setLoading(false);
    }
  };

  const filterOffers = () => {
    if (statusFilter === 'all') {
      setFilteredOffers(offers);
    } else {
      setFilteredOffers(offers.filter(offer => offer.status === statusFilter));
    }
  };

  const getStatusBadge = (status) => {
    const badges = {
      draft: { text: 'Taslak', class: 'badge-draft' },
      pending: { text: 'Onay Bekliyor', class: 'badge-pending' },
      approved: { text: 'Onaylandı', class: 'badge-approved' },
      sent: { text: 'Gönderildi', class: 'badge-sent' },
      rejected: { text: 'Reddedildi', class: 'badge-rejected' }
    };
    const badge = badges[status] || { text: status, class: '' };
    return <span className={`status-badge ${badge.class}`}>{badge.text}</span>;
  };

  const formatCurrency = (amount, currency) => {
    const symbols = { EUR: '€', USD: '$', TRY: '₺', GBP: '£' };
    return `${parseFloat(amount).toFixed(2)} ${symbols[currency] || currency}`;
  };

  if (loading) {
    return (
      <div className="offer-list-page">
        <div className="loading-state">
          <div className="loading-spinner"></div>
          <p>Teklifler yükleniyor...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="offer-list-page">
      <div className="page-header">
        <h1>📋 Tüm Teklifler</h1>
        <div className="header-actions">
          <button className="btn-back" onClick={() => navigate('/dashboard')}>
            ← Dashboard
          </button>
          <button className="btn-primary" onClick={() => navigate('/offers/create')}>
            ➕ Yeni Teklif
          </button>
        </div>
      </div>

      <div className="filters">
        <div className="filter-group">
          <label>Durum Filtresi</label>
          <select value={statusFilter} onChange={(e) => setStatusFilter(e.target.value)}>
            <option value="all">Tümü ({offers.length})</option>
            <option value="draft">Taslak ({offers.filter(o => o.status === 'draft').length})</option>
            <option value="pending">Onay Bekliyor ({offers.filter(o => o.status === 'pending').length})</option>
            <option value="approved">Onaylandı ({offers.filter(o => o.status === 'approved').length})</option>
            <option value="sent">Gönderildi ({offers.filter(o => o.status === 'sent').length})</option>
            <option value="rejected">Reddedildi ({offers.filter(o => o.status === 'rejected').length})</option>
          </select>
        </div>
      </div>

      <div className="offers-container">
        {filteredOffers.length === 0 ? (
          <div className="empty-state">
            <div className="empty-icon">📭</div>
            <h3>Teklif Bulunamadı</h3>
            <p>
              {statusFilter === 'all' 
                ? 'Henüz hiç teklif oluşturulmamış.'
                : `Bu durumda teklif bulunmuyor.`}
            </p>
            <button className="btn-primary" onClick={() => navigate('/offers/create')}>
              ➕ İlk Teklifi Oluştur
            </button>
          </div>
        ) : (
          <div className="offers-table-wrapper">
            <table className="offers-table">
              <thead>
                <tr>
                  <th>Teklif No</th>
                  <th>Müşteri</th>
                  <th>Tarih</th>
                  <th>Geçerlilik</th>
                  <th>Tutar</th>
                  <th>Hazırlayan</th>
                  <th>Durum</th>
                </tr>
              </thead>
              <tbody>
                {filteredOffers.map((offer, index) => (
                  <tr 
                    key={offer.id} 
                    onClick={() => navigate(`/offers/${offer.id}`)}
                    style={{animationDelay: `${index * 0.05}s`}}
                  >
                    <td>
                      <strong>{offer.offer_number}</strong>
                    </td>
                    <td>{offer.customer_name}</td>
                    <td>{new Date(offer.offer_date).toLocaleDateString('tr-TR')}</td>
                    <td>
                      {offer.validity_date 
                        ? new Date(offer.validity_date).toLocaleDateString('tr-TR')
                        : '-'}
                    </td>
                    <td>
                      <strong>{formatCurrency(offer.total, offer.currency)}</strong>
                    </td>
                    <td>{offer.prepared_by}</td>
                    <td>{getStatusBadge(offer.status)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}

export default OfferList;
